import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ShowMore = (props) => {
  const { text, length } = props;
  const [showMore, setShowMore] = useState(null);
  const [result, setResult] = useState(text);

  useEffect(() => {
    if (text != null && text.length > length) {
      setShowMore(true);
      setResult(text.substring(0, length));
    } else {
      setResult(text);
    }
  }, [text]);

  const showMoreAction = () => {
    setShowMore(false);
    setResult(text);
  };

  const showLessAction = () => {
    setShowMore(true);
    setResult(text.substring(0, length));
  };

  return (
    <React.Fragment>
      {result}
      {showMore === true && <MoreHorizIcon style={{ position: 'relative', top: 7, cursor: 'pointer' }} color="primary" onClick={showMoreAction} />}
      {showMore === false && <ExpandLessIcon style={{ position: 'relative', top: 7, cursor: 'pointer' }} color="primary" onClick={showLessAction} />}
    </React.Fragment>
  );
};

ShowMore.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
};

export default ShowMore;
